import { render, staticRenderFns } from "./ConfigurarCobroVenta.vue?vue&type=template&id=05ab864c"
import script from "./ConfigurarCobroVenta.vue?vue&type=script&lang=js"
export * from "./ConfigurarCobroVenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports